import { defineComponent as _defineComponent } from 'vue'
import VFooter from "@/components/vFooter.vue";
import {useTranslations} from "@/hooks/useTranslations";
import {useRoute, useRouter} from "vue-router/composables";
import {onMounted, ref} from "vue";
import {useStore} from "@/hooks/useStore";
import {FETCH_USER_DETAILS, TRANSLATIONS_FETCH} from "@/store/ActionTypes";
import FreeTrialSignupForm from "@/components/forms/Signup/FreeTrialSignupForm.vue";
import {useNotify} from "@/hooks/useNotify";
import SignupDto from "@/models/Restaurants/SignupDto";
import UserRepository from "@/utils/API/UserRepository";
import {
  buildSocialBeginUrl,
  clearSocialSignup,
  GOOGLE_PROVIDER,
  handleSocialCallback,
  loadSocialSignup,
  navigateSafely,
  saveSocialSignup,
  SOCIAL_TRIAL_SIGNUP_MODE,
} from "@/utils/socialAuth";
import {SET_AUTH_STATE} from "@/store/MutationTypes";
import {AuthStates} from "@/store/modules/AccountModule";


export default /*#__PURE__*/_defineComponent({
  __name: 'FreeTrialSignup',
  setup(__props) {

const translations = useTranslations();
const route = useRoute();
const router = useRouter();
const store = useStore();
const notify = useNotify();
const isGoogleSignupProcessing = ref(false);

onMounted(async() => {
  await store.value.dispatch(TRANSLATIONS_FETCH, {
    category: "pages",
    collections: [
      "common",
      "login",
      "customers",
      "managesubscription",
      "profile",
    ],
  });
  await handleGoogleCallback();
});

function handleGoogleSignupRequested(signup: SignupDto) {
  saveSocialSignup(GOOGLE_PROVIDER, SOCIAL_TRIAL_SIGNUP_MODE, signup);
  window.location.href = buildSocialBeginUrl(GOOGLE_PROVIDER, SOCIAL_TRIAL_SIGNUP_MODE);
}

async function handleGoogleCallback() {
  const completed = await handleSocialCallback({
    provider: GOOGLE_PROVIDER,
    expectedMode: SOCIAL_TRIAL_SIGNUP_MODE,
    router,
    route,
    onProviderError: (message) => notify.error(message),
    onComplete: async (code) => {
      const signup = loadSocialSignup(GOOGLE_PROVIDER, SOCIAL_TRIAL_SIGNUP_MODE);
      if (!signup) {
        notify.error(translations.value.get("google_signup_details_not_found"));
        return false;
      }

      isGoogleSignupProcessing.value = true;
      const response = await UserRepository.completeGoogleSignup({code, signup});
      await store.value.dispatch(FETCH_USER_DETAILS);
      store.value.commit(SET_AUTH_STATE, {
        authState: AuthStates.Success,
        authMessage: response.statusText || "OK",
      });
      return true;
    },
    onFailure: (error: any) => {
      isGoogleSignupProcessing.value = false;
      const message = error.response?.data?.errorMessages?.[0]?.userVisibleMessage
        || translations.value.get("google_signup_failed");
      notify.error(message);
    },
  });

  if (!completed) {
    return;
  }

  clearSocialSignup(GOOGLE_PROVIDER, SOCIAL_TRIAL_SIGNUP_MODE);
  await navigateSafely(router, "/");
}

return { __sfc: true,translations, route, router, store, notify, isGoogleSignupProcessing, handleGoogleSignupRequested, handleGoogleCallback, VFooter, FreeTrialSignupForm }
}

})